import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { VertexCreditMemoRequest } from "models/vertex-credit-memo";
import { useAuth } from "src/contexts/AuthContext";

export const useCreditMemoSendRequest = (requestId: string) => {
  const [request, setRequest] = useState<VertexCreditMemoRequest | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const fetchRequest = async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(`${API_URL}/credit-memos/${id}`, {
        method: "GET",
      });
      const data = await checkResponse(response);
      setRequest(data);
    } catch (err) {
      console.error("Error fetching credit memo send request:", err);
      setError("Failed to fetch the credit memo send request.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (requestId) {
      fetchRequest(requestId);
    }
  }, [requestId]);

  return {
    request,
    loading,
    error,
    refetch: () => fetchRequest(requestId),
  };
};
